import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Doctor } from 'src/app/Models/doctor.model';
import { DoctorReport } from 'src/app/Models/doctorreport.model';
import { DoctorReportService } from 'src/app/services/doctor-report.service';
import { DoctorService } from 'src/app/services/doctor.service';
import { VoiceRecognitionObjectiveService } from 'src/app/services/voice-recognition-objective.service';
import { VoiceRecognitionService } from 'src/app/services/voice-recognition.service';

@Component({
  selector: 'app-add-doctor-report',
  templateUrl: './add-doctor-report.component.html',
  styleUrls: ['./add-doctor-report.component.css'],
})
export class AddDoctorReportComponent implements OnInit {
  id = 0;
  reportList: DoctorReport[] = [];
  isSuccess = false;
  helper = new JwtHelperService();
  myToken = window.localStorage.getItem('token');
  UserId: number = 0;
  doctor: Doctor;
  listening = false;
  listeningReportName: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private doctorReportService: DoctorReportService,
    private route: ActivatedRoute,
    public service: VoiceRecognitionService,
    public serviceObjective: VoiceRecognitionObjectiveService,

    private doctorService: DoctorService
  ) {
    this.service.init();
    this.serviceObjective.init();
  }

  ngOnInit(): void {
    let decodedToken = this.helper.decodeToken(this.myToken);
    this.UserId = parseInt(decodedToken.nameid);

    this.route.params.subscribe((res) => {
      this.id = res['id'];
    });

    this.getDoctor(this.UserId);
  }

  Frm = this.fb.group({
    ReportName: ['', Validators.required],
    ReportDescription: ['', Validators.required],
  });

  getReportName() {
    return this.Frm.get('ReportName');
  }

  getReportDescription() {
    return this.Frm.get('ReportDescription');
  }

  tabChanged(event: MatTabChangeEvent): void {
    if (event.index === 0) {
      this.getReportName();
    }
  }

  startService() {
    this.service.start();
    this.listening = true;
  }

  stopService() {
    this.service.stop();
    this.listening = false;
  }

  onSubjectiveChange(e) {
    this.service.message1 = e.target.value;
  }

  onSubjectiveBlur() {
    this.stopService();
  }

  startServiceObjective() {
    this.serviceObjective.startObjective();
    this.listeningReportName = true;
  }

  stopServiceObjective() {
    this.serviceObjective.stopObjective();
    this.listeningReportName = false;
  }

  onObjectiveChange(e) {
    this.serviceObjective.Objective = e.target.value;
  }

  onObjectiveBlur() {
    this.stopServiceObjective();
    this.stopService();
  }
  stopAll() {
    this.stopServiceObjective();
    this.stopService();
  }
  getDoctor(id) {
    this.doctorService.getDoctorById(id).subscribe((res) => {
      this.doctor = res;
    });
  }

  formSubmit() {
    let ReportName = this.Frm.value['ReportName'];
    let reportDescription = this.Frm.value['ReportDescription'];

    let body = {
      PatientId: this.id,
      DoctorId: this.UserId,
      ReportName: ReportName,
      ReportDescription: reportDescription,
      DoctorName: this.doctor.DoctorName,
    };

    this.doctorReportService.registerDoctorReport(body).subscribe((res) => {
      this.isSuccess = true;
      this.Frm.reset();
    });
  }
}
